export default __webpack_public_path__ + "static/media/serviceBlock1.20863f5c.jpeg";